import { store } from "@irati/store";
import authentication from "@irati/auth";
import RewardService from "@irati/reward/apollo/Reward";
import StatementItemTypes from "@irati/wallet/types/enums/StatementItemTypes";
import { getNormalisedValue } from "@irati/utils/currency/formatCurrency";
import { PaymentProvider, WalletType } from "../enums/PaymentV2";
import endpoints from "../endpoints";
export default function (provider, paymentOrder, details, channel) {
    switch (provider) {
        case PaymentProvider.AdyenClassic:
            return makeAdyenPayload(paymentOrder, details);
        case PaymentProvider.Adyen:
            return makeAdyenDropInPayload(paymentOrder, details, channel);
        default:
            throw new Error("Unknown payment provider");
    }
}
function mapLocaleToAdyenLocale(locale) {
    switch (locale) {
        case "fr-FR":
            return "fr";
        default:
            return "en_GB";
    }
}
function makeAdyenPayload(paymentOrder, details) {
    return {
        provider: PaymentProvider.AdyenClassic,
        currency: paymentOrder.currency,
        amount: details.amount,
        enableSaveCardOption: details.enableSaveCardOption,
        details: {
            shopperEmail: authentication.user().email,
            shopperLocale: mapLocaleToAdyenLocale(authentication.userLocale()),
            // temporarily adding result callback url until we get adyen AU account setup
            resURL: details.resUrl || endpoints.adyenCallbackUrl()
        }
    };
}
function makeAdyenDropInPayload(paymentOrder, details, channel) {
    return {
        provider: PaymentProvider.Adyen,
        currency: paymentOrder.currency,
        amount: details.amount,
        enableSaveCardOption: details.enableSaveCardOption,
        details: {
            shopperEmail: authentication.user().email,
            shopperLocale: mapLocaleToAdyenLocale(authentication.userLocale()),
            channel: channel
        }
    };
}
export function makePaymentWalletPayload(paymentOrder, details, deal, redemptionId) {
    var userWallet = store.getState().wallet;
    return {
        provider: PaymentProvider.Wallet,
        currency: paymentOrder.currency,
        amount: details.amount,
        details: {
            sourceOwnerId: userWallet.ownerUuid,
            sourceWalletId: userWallet.uuid,
            reference: {
                dealHeader: deal.header,
                dealThumbnailImage: deal.thumbnailImage,
                orderTotal: {
                    currency: paymentOrder.currency,
                    value: getNormalisedValue(true, paymentOrder.currency, details.amount)
                },
                redemptionUuid: redemptionId,
                type: StatementItemTypes.SPEND
            }
        }
    };
}
export function makePaymentRewardWalletPayload(paymentOrder, details, rewardOrder) {
    return RewardService.getWallet().then(function (rewardWallet) {
        return {
            provider: PaymentProvider.Wallet,
            currency: paymentOrder.currency,
            amount: details.amount,
            details: {
                sourceOwnerId: rewardWallet.ownerUuid,
                sourceWalletId: rewardWallet.walletUuid,
                walletType: WalletType.Rewards,
                reference: {
                    service: "rewards-wallet",
                    version: "FE",
                    type: "use-credit-to-buy-reward",
                    order_id: rewardOrder.uuid,
                    rewards_wallet_id: rewardWallet.uuid
                }
            }
        };
    });
}
export function makeZipPayload(paymentOrder, details) {
    return {
        provider: PaymentProvider.Zip,
        currency: paymentOrder.currency,
        amount: details.amount,
        details: {
            resURL: details.resUrl
        }
    };
}
